import React from 'react';
import PageNavigation from './PageNavigation';
import PageSizeControl from './PageSizeControl';

const Pagination = ({ pageable, onPageSizeChangeAction, onNextPageClickAction, onPrevPageClickAction }) => {
  return (
    <div className="grid grid-cols-2 items-center justify-between">
      <PageSizeControl pageable={pageable} onPageSizeChange={onPageSizeChangeAction} />
      <PageNavigation
        pageable={pageable}
        onNextPageClickAction={onNextPageClickAction}
        onPrevPageClickAction={onPrevPageClickAction}
      />
    </div>
  );
};

export default Pagination;
